import { render, staticRenderFns } from "./HorizontalSidebar.vue?vue&type=template&id=04f6fb48"
import script from "./HorizontalSidebar.vue?vue&type=script&lang=js"
export * from "./HorizontalSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports